import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  statusCompleted: {
    borderLeft: '4px solid #4caf50',
  },
  statusPending: {
    borderLeft: '4px solid #ff9800',
  },
  titleStyle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
  },
  iconStyle: {
    fontSize: '20px',
    cursor: 'pointer',
    margin: '0 5px',
    '&:hover': {
      color: '#1976d2',
    },
  },
  paginationStyle: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  tableToolbar: {
    marginBottom: '16px',
    paddingBottom: '8px',
  },
  tableContainer: {
    borderRadius: 8,
    border: '1px solid #e0e0e0',
    overflowX: 'auto',
  },
});

export { useStyles };
